import { Component } from 'react';
import * as styles from './styles/styles.module.scss';
import DatePicker from '@alltrails/shared/components/DatePicker';

import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { getPrimaryIndex } from '../../../utils/search';

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class BannerManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentBanners: [],
      newStartDate: new Date(),
      newEndDate: new Date(),
      countries: '',
      countryNames: null,
      displayMessage: null,
      createNewBannerMode: false
    };
    this.algoliaIndex = getPrimaryIndex(this.props.context.languageRegionCode);
  }

  componentDidMount() {
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/admin/banners',
      {},
      this.handleCurrentBannerResults,
      () => {},
      () => {}
    );
  }

  toggleCreateMode = e => {
    this.setState({ createNewBannerMode: !this.state.createNewBannerMode });
  };

  handleBannerCreateSuccess = data => {
    // todo: make this a cleaner UX
    window.location.reload();
  };

  saveNewBannerClick = e => {
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/admin/banners',
      {
        couponCode: this.state.newCouponText,
        startDate: this.state.newStartDate,
        endDate: this.state.newEndDate,
        countries: this.countriesFormatted(this.state.countries),
        message: this.state.newMessageText
      },
      this.handleBannerCreateSuccess,
      () => {},
      () => {}
    );
  };

  countriesFormatted = countries => {
    if (countries == '' || !countries) {
      return [];
    }

    return countries
      .split(',')
      .map(s => s.trim())
      .filter(isNumeric);
  };

  previewCountryNames = countryIds => {
    if (countryIds && countryIds.length > 0) {
      const filters = countryIds.map(id => `objectID:country-${id}`);
      this.algoliaIndex
        .search('', {
          facetFilters: [filters],
          hitsPerPage: 1000
        })
        .then(this.handleCountriesResults)
        .catch(err => console.error(err));
    }
  };

  handleCountriesResults = content => {
    if (content.hits && content.hits.length > 0) {
      const countryNames = content.hits.map(hit => `${hit.ID}:${hit.name}`).join(', ');
      this.setState({ countryNames });
    }
  };

  handleCurrentBannerResults = data => {
    this.setState({ currentBanners: data });
  };

  handleOnNewCodeInputChange = e => {
    e.preventDefault();
    this.setState({ newCouponText: e.currentTarget.value });
  };

  handleOnNewMessageChange = e => {
    e.preventDefault();
    this.setState({ newMessageText: e.currentTarget.value });
  };

  handleOnNewCountriesChange = e => {
    e.preventDefault();
    this.setState({ countries: e.currentTarget.value, countryNames: null });
    this.previewCountryNames(this.countriesFormatted(e.currentTarget.value));
  };

  handleStartDateChange = newStartDate => {
    this.setState({ newStartDate });
  };

  handleEndDateChange = newEndDate => {
    this.setState({ newEndDate });
  };

  renderBannerDiv(banner) {
    const startDateParsed = new Date(banner.startDate);
    const endDateParsed = new Date(banner.endDate);
    const options = {
      date: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      time: { timeZoneName: 'short' }
    };
    const countries = banner.countriesFormatted || banner.countries || 'All';
    return (
      <div key={banner.id} className={styles.couponCard}>
        <h4>
          Link:{' '}
          <a href={`/plus?k=${banner.code}`} target="_blank">
            Here
          </a>
        </h4>
        <h4>{`Type: ${banner.type}`}</h4>
        <h4>{`Message: ${banner.message}`}</h4>
        <h4>{`Countries: ${countries}`}</h4>
        <h4>{`Start date: ${startDateParsed.toLocaleDateString('en-US', options.date)} ${startDateParsed.toLocaleTimeString(
          'en-US',
          options.time
        )}`}</h4>
        <h4>{`End date: ${endDateParsed.toLocaleDateString('en-US', options.date)}`}</h4>
        <a href={`/edit-translations?table=banners&column_name=message&id=${banner.id}`}>Edit Translations</a>
      </div>
    );
  }

  renderCurrentBannerDisplay() {
    if (this.state.createNewBannerMode) {
      return null;
    }

    const bannerElements = this.state.currentBanners.map(b => this.renderBannerDiv(b));

    return <div className={styles.couponBoxContainer}>{bannerElements}</div>;
  }

  renderNewBannerForm() {
    if (this.state.createNewBannerMode) {
      const countriesLegend =
        this.state.countryNames ||
        'List of database country ids, eg. 115,242 for Australia and New Zealand. Ids can be found in the Countries table on chart.io.';
      return (
        <div>
          <button className={styles.searchButtons} onClick={this.toggleCreateMode}>
            Cancel
          </button>
          <button className={styles.searchButtons} onClick={this.saveNewBannerClick}>
            Save
          </button>
          <div>
            <div className={styles.inputEditContainer}>
              <input
                onChange={this.handleOnNewCodeInputChange}
                value={this.state.newCouponText}
                className={styles.searchBox}
                placeholder="Enter new coupon code"
              />
            </div>
            <div className={styles.inputEditContainer}>
              <input
                onChange={this.handleOnNewMessageChange}
                value={this.state.newMessage}
                className={styles.searchBox}
                placeholder="Enter message"
              />
            </div>
            <div className={styles.inputEditContainer}>
              <label>Countries in which to display the banner. (Leave blank for all countries)</label>
              <legend>{countriesLegend}</legend>
              <input
                onChange={this.handleOnNewCountriesChange}
                value={this.state.countries}
                className={styles.searchBox}
                placeholder="Comma separated country ids"
              />
            </div>
            <label>Start date/time</label>
            <DatePicker date={this.state.newStartDate} onChange={this.handleStartDateChange} disableFuture={false} languageRegionCode={this.props.context.languageRegionCode} showTime />
            <label>End date/time</label>
            <DatePicker date={this.state.newEndDate} onChange={this.handleEndDateChange} disableFuture={false} languageRegionCode={this.props.context.languageRegionCode} showTime />
          </div>
        </div>
      );
    }
    return null;
  }

  renderButtonDiv() {
    if (this.state.createNewBannerMode) {
      return null;
    }
    return (
      <button className={styles.searchButtons} onClick={this.toggleCreateMode}>
        Create banner
      </button>
    );
  }

  renderTitleDiv() {
    let title = null;
    if (this.state.createNewBannerMode) {
      title = 'Creating a banner';
    } else {
      title = 'View all banners';
    }
    return <h2>{title}</h2>;
  }

  render() {
    return (
      <div className={styles.container}>
        {this.renderTitleDiv()}
        {this.renderButtonDiv()}
        {this.renderCurrentBannerDisplay()}
        {this.renderNewBannerForm()}
      </div>
    );
  }
}

export default BannerManager;
